module.exports = __webpack_public_path__ + "images/marco.e3fbd3bf10.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/marco.jpg
// module id = pzSf
// module chunks = 2